<template>
  <div class="search whaty-search-select" ref="whatySearchDate" v-clickoutside="handleClose">
    <div :class="['input-wrap', 'input-hasicon', menuShow && 'active']"
         @mouseenter="hovering = true"
         @mouseleave="hovering = false">
      <div class="el-input el-input--mini el-input--prefix el-input--suffix" v-show="inputValueShow">
        <input class="form-control" type="text"
               v-model="dataValue"
               @click="handleSwitch"
               @change="handleChange"
               autocomplete="off"
               style="padding-right:30px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap; "
               :placeholder="placeholder"
               ref="searchInput"
               readonly
        >
        <span class="input-icon" v-show="!nannSearch"><i class="mng icon-calendar-stroke"></i></span>
        <div class="input-append select-icon" @click="handleSwitch">
          <a data-role="select" class="btn btn-icon"><i class="mng icon-arrow-down-fill"></i></a>
        </div>
      </div>
      <div v-if="nannSearch" @click="menuShow = true"
           class="nann-tip-wrapper">
        <el-tag v-if="nannSearch === '!null'" size="mini">已填写</el-tag>
        <el-tag v-if="nannSearch === 'null'" size="mini">未填写</el-tag>
      </div>
      <span class="el-input__suffix" style="margin-right: 14px;">
        <span class="el-input__suffix-inner">
          <i v-if="showClear" @click="clear" class="el-input__icon el-icon-circle-close el-input__clear"></i>
        </span>
      </span>

      <div class="drop drop-base el-date__clear"  data-stopPropagation="true" :style="dropStyle" style="line-height:0;display: block;position: fixed" data-timeSearch="drop-filter" v-show="menuShow">
        <div class="drop-top drop-fix">
          <ul>
            <li class="drop-list">
              <a href="javascript:;" class="drop-link" @click="chooseRange">
                <span class="drop-txt">选范围</span>
                <i class="mng icon-lineArrR-stroke drop-ico-suf" style="margin-top: 0"></i>
              </a>
            </li>
            <li class="drop-list">
              <a href="javascript:;" class="drop-link" @click="chooseDay">
                <span class="drop-txt">选天</span>
                <i class="mng icon-lineArrR-stroke drop-ico-suf" style="margin-top: 0"></i>
              </a>
            </li>
          </ul>
        </div>
        <div class="drop-mid">
          <ul class="drop-list-wrap" data-action="activeCurrent">
            <li class="drop-list">
              <a href="javascript:;" class="drop-link" @click="chooseThisWeek">
                <span class="drop-txt">本周</span>
                <i class="mng icon-tick-stroke drop-ico-tick drop-ico-suf"></i>
              </a>
            </li>
            <li class="drop-list">
              <a href="javascript:;" class="drop-link" @click="chooseLastWeek">
                <span class="drop-txt">上周</span>
                <i class="mng icon-tick-stroke drop-ico-tick drop-ico-suf"></i>
              </a>
            </li>
            <li class="drop-list">
              <a href="javascript:;" class="drop-link" @click="chooseThisMonth">
                <span class="drop-txt">本月</span>
                <i class="mng icon-tick-stroke drop-ico-tick drop-ico-suf"></i>
              </a>
            </li>
            <li class="drop-list">
              <a href="javascript:;" class="drop-link" @click="chooseLastMonth">
                <span class="drop-txt">上月</span>
                <i class="mng icon-tick-stroke drop-ico-tick drop-ico-suf"></i>
              </a>
            </li>
            <li class="drop-list">
              <a href="javascript:;" class="drop-link" @click="chooseThisYear">
                <span class="drop-txt">本年</span>
                <i class="mng icon-tick-stroke drop-ico-tick drop-ico-suf"></i>
              </a>
            </li>
            <li class="drop-list">
              <a href="javascript:;" class="drop-link" @click="chooseLastYear">
                <span class="drop-txt">上年</span>
                <i class="mng icon-tick-stroke drop-ico-tick drop-ico-suf"></i>
              </a>
            </li>
          </ul>
        </div>
        <div class="drop-bot" v-if="isNeedNull === '0'">
          <ul data-action="activeCurrent">
            <li class="drop-list">
              <a href="javascript:;" :class="{active: nannSearch === '!null'}" class="drop-link" data-role="activeTarget"
                 @click="handleNANNSearchChange('!null')">
                <span class="drop-txt">已填写</span>
              </a>
            </li>
            <li class="drop-list">
              <a href="javascript:;" :class="{active: nannSearch === 'null'}" class="drop-link" data-role="activeTarget"
                 @click="handleNANNSearchChange('null')">
                <span class="drop-txt">未填写</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <!-- 单独选天的展示框 -->
      <div v-show="chooseDayMenuShow"
           class="el-picker-panel el-date-picker el-popper"
           style="position: fixed;z-index: 2063;"
           :style="chooseMenuStyle">
        <div class="el-picker-panel__body-wrapper">
          <slot name="sidebar" class="el-picker-panel__sidebar"></slot>
          <div class="el-picker-panel__body">
            <div class="el-picker-panel__content el-date-picker__content">
              <div class="el-date-picker__header">
                <button
                  type="button"
                  @click="leftPrevYear"
                  class="el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-d-arrow-left"></button>
                <button
                  type="button"
                  v-show="currentLeftView === 'date'"
                  @click="leftPrevMonth"
                  class="el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-arrow-left"></button>
                <span
                  @click="showYearPicker('left')"
                  role="button"
                  class="el-date-picker__header-label">{{ leftYearLabel }}</span>
                <span
                  @click="showMonthPicker('left')"
                  v-show="currentLeftView === 'date'"
                  role="button"
                  class="el-date-picker__header-label"
                  :class="{ active: currentLeftView === 'month' }">{{ this.leftDate.getMonth() + 1 }} 月</span>
                <button
                  type="button"
                  @click="leftNextYear"
                  v-if="unlinkPanels"
                  class="el-picker-panel__icon-btn el-date-picker__next-btn el-icon-d-arrow-right"></button>
                <button
                  type="button"
                  @click="leftNextMonth"
                  v-if="unlinkPanels"
                  v-show="currentLeftView === 'date'"
                  class="el-picker-panel__icon-btn el-date-picker__next-btn el-icon-arrow-right"></button>
              </div>
              <date-table
                v-show="currentLeftView === 'date'"
                :date="leftDate"
                :default-value="defaultValue"
                :disabled-date="disabledDate"
                @pick="handleDatePick"
                :selection-mode="selectionMode"
                :first-day-of-week="firstDayOfWeek">
              </date-table>
              <year-table
                v-show="currentLeftView === 'year'"
                @pick="handleYearPick($event, 'left')"
                :value="leftDate"
                :default-value="defaultValue ? new Date(defaultValue) : null"
                :date="leftDate"
                :disabled-date="disabledDate">
              </year-table>
              <month-table
                v-show="currentLeftView === 'month'"
                @pick="handleMonthPick($event, 'left')"
                :value="leftDate"
                :default-value="defaultValue ? new Date(defaultValue) : null"
                :date="leftDate"
                :disabled-date="disabledDate">
              </month-table>
            </div>
          </div>
        </div>
      </div>
      <!-- 选择天数结束 -->
      <!-- 单独选范围的展示框 -->
      <div v-show="chooseRangeMenuShow"
          class="el-picker-panel el-date-range-picker el-popper"
          style="position: fixed;z-index: 1500;width: 582px;"
          :style="chooseMenuStyle">
        <div class="el-picker-panel__body-wrapper">
          <slot name="sidebar" class="el-picker-panel__sidebar"></slot>
          <!-- 顶部显示框 start -->
          <div class="el-date-range-picker__time-header" style="display: flex">
            <span style="display: table">
              <span class="el-date-range-picker__editors-wrap" :class="{'datetime-range-picker' : dateType === 'datetime', 'date-range-picker' : dateType === 'date'}">
                <el-input
                  size="small"
                  v-model="minVisibleDate"
                  placeholder="开始日期"
                  readonly
                  class="el-date-range-picker__editor" />
              </span>
              <span class="el-date-range-picker__editors-wrap datetime-range-picker" v-if="dateType === 'datetime'">
                <el-time-picker
                  v-model="minTime"
                  format="HH:mm"
                  value-format="HH:mm"
                  class="el-date-range-picker__editor"
                  prefix-icon="null"
                  clear-icon="null"
                  size="small"
                  @focus="clickTime()"
                  :disabled="chickTimeShow"
                  :append-to-body="false"
                  placeholder="开始时间">
                </el-time-picker>
              </span>
            </span>
            <span style="padding: 0 5px 0 5px;font-size: 16px;">至</span>
            <span style="display: table">
              <span class="el-date-range-picker__editors-wrap is-right" :class="{'datetime-range-picker' : dateType === 'datetime', 'date-range-picker' : dateType === 'date'}">
                <el-input
                  size="small"
                  v-model="maxVisibleDate"
                  placeholder="结束日期"
                  readonly
                  class="el-date-range-picker__editor" />
              </span>
              <span class="el-date-range-picker__editors-wrap datetime-range-picker" v-if="dateType === 'datetime'">
                <el-time-picker
                  v-model="maxTime"
                  format='HH:mm'
                  value-format="HH:mm"
                  class="el-date-range-picker__editor"
                  prefix-icon="null"
                  clear-icon="null"
                  size="small"
                  :disabled="chickTimeShow"
                  :append-to-body="false"
                  @focus="clickTime()"
                  placeholder="结束时间">
                </el-time-picker>
              </span>
            </span>
          </div>
          <!-- 顶部显示框 end -->
          <div class="el-picker-panel__body">
            <div class="el-picker-panel__content el-date-range-picker__content is-left">
              <div class="el-date-range-picker__header">
                <button
                  type="button"
                  @click="leftPrevYear"
                  class="el-picker-panel__icon-btn el-icon-d-arrow-left"></button>
                <button
                  type="button"
                  v-show="currentLeftView === 'date'"
                  @click="leftPrevMonth"
                  class="el-picker-panel__icon-btn el-icon-arrow-left"></button>
                <span
                  @click="showYearPicker('left')"
                  role="button"
                  class="el-date-picker__header-label">{{ leftYearLabel }}</span>
                <span
                  @click="showMonthPicker('left')"
                  v-show="currentLeftView === 'date'"
                  role="button"
                  class="el-date-picker__header-label"
                  :class="{ active: currentLeftView === 'month' }">{{ this.leftDate.getMonth() + 1 }} 月</span>
                <button
                  type="button"
                  @click="leftNextYear"
                  v-if="unlinkPanels"
                  class="el-picker-panel__icon-btn el-icon-d-arrow-right"></button>
                <button
                  type="button"
                  @click="leftNextMonth"
                  v-if="unlinkPanels"
                  v-show="currentLeftView === 'date'"
                  class="el-picker-panel__icon-btn el-icon-arrow-right"></button>
              </div>
              <date-table
                v-show="currentLeftView === 'date'"
                selection-mode="range"
                :date="leftDate"
                :default-value="defaultValue"
                :min-date="minDate"
                :max-date="maxDate"
                :range-state="rangeState"
                :disabled-date="disabledDate"
                @changerange="handleChangeRange"
                @pick="handleRangePick"
                :first-day-of-week="firstDayOfWeek">
              </date-table>
              <year-table
                v-show="currentLeftView === 'year'"
                @pick="handleYearPick($event, 'left')"
                :value="leftDate"
                :default-value="defaultValue ? new Date(defaultValue) : null"
                :date="leftDate"
                :disabled-date="disabledDate">
              </year-table>
              <month-table
                v-show="currentLeftView === 'month'"
                @pick="handleMonthPick($event, 'left')"
                :value="leftDate"
                :default-value="defaultValue ? new Date(defaultValue) : null"
                :date="leftDate"
                :disabled-date="disabledDate">
              </month-table>
            </div>
            <div class="el-picker-panel__content el-date-range-picker__content is-right">
              <div class="el-date-range-picker__header">
                <button
                  type="button"
                  @click="rightPrevYear"
                  v-if="unlinkPanels"
                  class="el-picker-panel__icon-btn el-icon-d-arrow-left"></button>
                <button
                  type="button"
                  v-show="currentRightView === 'date'"
                  @click="rightPrevMonth"
                  v-if="unlinkPanels"
                  class="el-picker-panel__icon-btn el-icon-arrow-left"></button>
                <span
                  @click="showYearPicker('right')"
                  role="button"
                  class="el-date-picker__header-label">{{ rightYearLabel }}</span>
                <span
                  @click="showMonthPicker('right')"
                  v-show="currentRightView === 'date'"
                  role="button"
                  class="el-date-picker__header-label"
                  :class="{ active: currentRightView === 'month' }">{{ this.rightDate.getMonth() + 1 }} 月</span>
                <button
                  type="button"
                  @click="rightNextYear"
                  class="el-picker-panel__icon-btn el-icon-d-arrow-right"></button>
                <button
                  type="button"
                  v-show="currentRightView === 'date'"
                  @click="rightNextMonth"
                  class="el-picker-panel__icon-btn el-icon-arrow-right"></button>
              </div>
              <date-table
                v-show="currentRightView === 'date'"
                selection-mode="range"
                :date="rightDate"
                :default-value="defaultValue"
                :min-date="minDate"
                :max-date="maxDate"
                :range-state="rangeState"
                :disabled-date="disabledDate"
                @changerange="handleChangeRange"
                @pick="handleRangePick"
                :first-day-of-week="firstDayOfWeek">
              </date-table>
              <year-table
                v-show="currentRightView === 'year'"
                @pick="handleYearPick($event, 'right')"
                :value="rightDate"
                :default-value="defaultValue ? new Date(defaultValue) : null"
                :date="rightDate"
                :disabled-date="disabledDate">
              </year-table>
              <month-table
                v-show="currentRightView === 'month'"
                @pick="handleMonthPick($event, 'right')"
                :value="rightDate"
                :default-value="defaultValue ? new Date(defaultValue) : null"
                :date="rightDate"
                :disabled-date="disabledDate">
              </month-table>
            </div>
          </div>
        </div>
        <div class="search-select-footer">
            <div style="text-align: right">
              <el-button type="text" @click="clear">清空</el-button>
              <el-button plain @click="submitData" size="mini" :disabled="submitShow">确定</el-button>
            </div>
        </div>
      </div>
      <!-- 选择范围结束 -->
    </div>
  </div>
</template>

<script>
  import util from '../../libs/util'
  import Clickoutside from 'element-ui/src/utils/clickoutside'
  import YearTable from 'element-ui/packages/date-picker/src/basic/year-table'
  import MonthTable from 'element-ui/packages/date-picker/src/basic/month-table'
  import DateTable from 'element-ui/packages/date-picker/src/basic/date-table'
  import {
    formatDate,
    prevYear,
    nextYear,
    prevMonth,
    nextMonth,
    extractDateFormat,
    extractTimeFormat,
    modifyWithTimeString,
    modifyDate,
    changeYearMonthAndClampDate,
    clearMilliseconds,
    clearTime
  } from 'element-ui/src/utils/date-util'

  export default {
    name: 'whaty-search-date-picker',
    directives: { Clickoutside },
    props: {
      value: {
        required: true
      },
      size: {
        type: String,
        default: 'mini'
      },
      placeholder: {
        type: String
      },
      url: String,
      queryParams: {
        type: Object,
        default() {
          return {}
        }
      },
      valueIndex: {
        type: Number,
        default: 0
      },
      labelIndex: {
        type: Number,
        default: 1
      },
      isNeedNull: {
        type: String,
        default: '0'
      },
      dateType: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        menuShow: false, // 选择菜单是否显示
        focused: false,
        hovering: false,
        dataValue: '',
        nannSearch: '', // nann: null and not null, !null: 已填写, null: 未填写
        chooseDayMenuShow: false,
        chooseDayValue: '',
        inputValueShow: true,
        chooseRangeMenuShow: false,
        chooseRangeValue: '',
        leftDate: new Date(),
        rightDate: nextMonth(new Date()),
        defaultValue: null,
        minDate: '',
        maxDate: '',
        rangeState: {
          endDate: null,
          selecting: false,
          row: null,
          column: null
        },
        showTime: false,
        disabledDate: '',
        firstDayOfWeek: 7,
        unlinkPanels: true,
        currentLeftView: 'date',
        currentRightView: 'date',
        selectionMode: 'day',
        menuType: 'all',
        menuLeft: '0',
        submitShow: true,  // 确认按钮是否生效
        chickTimeShow: false, // 时间选择框是否生效
        minTime: '',
        maxTime: '',
        contentValue: '', // 提示信息
        dropStyle: { 'width': '208px', 'left': 0 }
      }
    },
    computed: {
      // dropStyle() {
      //   return {
      //     'width': '208px',
      //     'left': 0
      //   }
      // },
      showClear() {
        return ((this.dataValue && this.dataValue.length > 0) || this.nannSearch) &&
          (this.focused || this.hovering)
      },
      leftYearLabel() {
        const yearTranslation = '年'
        if (this.currentLeftView === 'year') {
          const startYear = Math.floor(this.year('left') / 10) * 10
          if (yearTranslation) {
            return startYear + ' ' + yearTranslation + ' - ' + (startYear + 9) + ' ' + yearTranslation
          }
          return startYear + ' - ' + (startYear + 9)
        }
        return this.year('left') + ' ' + yearTranslation
      },
      rightYearLabel() {
        const yearTranslation = '年'
        if (this.currentRightView === 'year') {
          const startYear = Math.floor(this.year('right') / 10) * 10
          if (yearTranslation) {
            return startYear + ' ' + yearTranslation + ' - ' + (startYear + 9) + ' ' + yearTranslation
          }
          return startYear + ' - ' + (startYear + 9)
        }
        return this.year('right') + ' ' + yearTranslation
      },
      leftYear() {
        return this.leftDate.getFullYear()
      },

      leftMonth() {
        return this.leftDate.getMonth()
      },

      leftMonthDate() {
        return this.leftDate.getDate()
      },

      rightYear() {
        return this.rightDate.getFullYear()
      },

      rightMonth() {
        return this.rightDate.getMonth()
      },

      rightMonthDate() {
        return this.rightDate.getDate()
      },

      minVisibleDate() {
        return this.minDate ? formatDate(this.minDate, this.dateFormat) : ''
      },

      maxVisibleDate() {
        return (this.maxDate || this.minDate) ? formatDate(this.maxDate || this.minDate, this.dateFormat) : ''
      },

      minVisibleTime() {
        return this.minDate ? formatDate(this.minDate, this.timeFormat) : ''
      },

      maxVisibleTime() {
        return (this.maxDate || this.minDate) ? formatDate(this.maxDate || this.minDate, this.timeFormat) : ''
      },

      timeFormat() {
        if (this.format) {
          return extractTimeFormat(this.format)
        } else {
          return 'HH:mm:ss'
        }
      },
      dateFormat() {
        if (this.format) {
          return extractDateFormat(this.format)
        } else {
          return 'yyyy-MM-dd'
        }
      },
      enableSearchMode() {
        return (this.dataValue && this.dataValue.length > 0)
      },
      chooseMenuStyle() {
        return {
          'left': this.menuLeft + 'px'
        }
      }
    },
    methods: {
      showMenu() {
        if (this.menuType === 'range') {
          this.chooseRangeMenuShow = true
          this.submitShow = false
        } else if (this.menuType === 'day') {
          this.chooseDayMenuShow = true
        } else {
          this.dropStyle = {'width': '208px', 'left': this.$refs.whatySearchDate.getBoundingClientRect().left + 'px'}
          this.chooseRangeMenuShow = false
          this.chooseDayMenuShow = false
          this.menuShow = true
        }
      },
      year(position) {
        if (position === 'left') {
          return this.leftDate.getFullYear()
        }
        return this.rightDate.getFullYear()
      },

      month(position) {
        if (position === 'left') {
          return this.leftDate.getMonth()
        }
        return this.rightDate.getMonth()
      },
      handleClose() { // 点击空白处
        this.menuShow = false
        this.chooseDayMenuShow = false
        this.inputValueShow = true
        this.chooseRangeMenuShow = false
        if (!(this.minDate && this.maxDate)) {
          this.minDate = ''
          this.maxDate = ''
          this.minTime = ''
          this.maxTime = ''
          this.rangeState.selecting = false
        }
      },
      handleChange(event) { // input值变化事件
        this.emitInput()
      },
      handleChangeRange(val) {
        this.minDate = val.minDate
        this.maxDate = val.maxDate
        this.rangeState = val.rangeState
      },
      handleRangePick(val, close = true) {
        this.menuType = 'range'
        const defaultTime = this.defaultTime || []
        const minDate = modifyWithTimeString(val.minDate, defaultTime[0])
        const maxDate = modifyWithTimeString(val.maxDate, defaultTime[1])

        if (this.maxDate === maxDate && this.minDate === minDate) {
          return
        }
        this.onPick && this.onPick(val)
        this.maxDate = maxDate
        this.minDate = minDate

        // workaround for https://github.com/ElemeFE/element/issues/7539, should remove this block when we don't have to care about Chromium 55 - 57
        setTimeout(() => {
          this.maxDate = maxDate
          this.minDate = minDate
        }, 10)
        // 是否选择完日期
        const selectDataAll = this.maxDate && this.minDate
        this.submitShow = !selectDataAll
        this.chickTimeShow = !selectDataAll
        if (selectDataAll && !(this.maxDate.getTime() === this.minDate.getTime())) {
          if (!this.minTime) {
            this.minTime = '00:00'
          }
          if (!this.maxTime) {
            this.maxTime = '23:59'
          }
        }
        // if (!close || this.showTime) return
        // if (this.maxDate && this.minDate) {
        //   this.chooseRangeMenuShow = false
        //   if (util.formatDate(this.minDate, 'yyyy-MM-dd') === util.formatDate(this.maxDate, 'yyyy-MM-dd')) {
        //     this.dataValue = util.formatDate(this.minDate, 'yyyy-MM-dd')
        //   } else {
        //     this.dataValue = util.formatDate(this.minDate, 'yyyy-MM-dd') + ' ~ ' + util.formatDate(this.maxDate, 'yyyy-MM-dd')
        //     this.leftDate = this.minDate
        //     this.rightDate = this.maxDate
        //   }
        //   this.emitInput()
        // }
      },
      emit(value, ...args) {
        if (!value) {
          this.$emit('pick', value, ...args)
        } else if (Array.isArray(value)) {
          const dates = value.map(date => this.showTime ? clearMilliseconds(date) : clearTime(date))
          this.$emit('pick', dates, ...args)
        } else {
          this.$emit('pick', this.showTime ? clearMilliseconds(value) : clearTime(value), ...args)
        }
      },
      showMonthPicker(position) {
        if (position === 'left') {
          this.currentLeftView = 'month'
        } else {
          this.currentRightView = 'month'
        }
      },
      showYearPicker(position) {
        if (position === 'left') {
          this.currentLeftView = 'year'
        } else {
          this.currentRightView = 'year'
        }
      },
      handleDatePick(value) {
        this.chooseDayMenuShow = false
        this.menuType = 'day'
        this.dataValue = util.formatDate(value, 'yyyy-MM-dd')
        this.contentValue = this.dataValue
        this.emitInput()
      },
      handleMonthPick(month, position) {
        if (position === 'left') {
          if (this.selectionMode === 'month') {
            this.leftDate = modifyDate(this.leftDate, this.year('left'), month, 1)
            this.emit(this.leftDate)
          } else {
            this.leftDate = changeYearMonthAndClampDate(this.leftDate, this.year('left'), month)
            this.currentLeftView = 'date'
          }
        } else {
          if (this.selectionMode === 'month') {
            this.rightDate = modifyDate(this.rightDate, this.year('right'), month, 1)
            this.emit(this.rightDate)
          } else {
            this.rightDate = changeYearMonthAndClampDate(this.rightDate, this.year('right'), month)
            this.currentRightView = 'date'
          }
        }
      },
      handleYearPick(year, position) {
        if (position === 'left') {
          if (this.selectionMode === 'year') {
            this.leftDate = modifyDate(this.leftDate, year, 0, 1)
            this.emit(this.leftDate)
          } else {
            this.leftDate = changeYearMonthAndClampDate(this.leftDate, year, this.month(position))
            this.currentLeftView = 'month'
          }
        } else {
          if (this.selectionMode === 'year') {
            this.rightDate = modifyDate(this.rightDate, year, 0, 1)
            this.emit(this.rightDate)
          } else {
            this.rightDate = changeYearMonthAndClampDate(this.rightDate, year, this.month(position))
            this.currentRightView = 'month'
          }
        }
      },
      chooseThisWeek() {
        const start = new Date()
        let n = start.getDay()
        if (n === 0) {
          n = 7
        }
        start.setDate(start.getDate() - n + 1)
        const end = new Date(start.getTime() + 3600 * 1000 * 24 * 6)
        this.menuShow = false
        this.dataValue = util.formatDate(start, 'yyyy-MM-dd') + ' ~ ' + util.formatDate(end, 'yyyy-MM-dd')
        this.contentValue = this.dataValue
        this.setDefaultDate(start, end)
        this.emitInput()
      },
      chooseLastWeek() {
        const start = new Date()
        start.setDate(start.getDate() - 7)
        let n = start.getDay()
        if (n === 0) {
          n = 7
        }
        start.setDate(start.getDate() - n + 1)
        const end = new Date(start.getTime() + 3600 * 1000 * 24 * 6)
        this.menuShow = false
        this.dataValue = util.formatDate(start, 'yyyy-MM-dd') + ' ~ ' + util.formatDate(end, 'yyyy-MM-dd')
        this.contentValue = this.dataValue
        this.setDefaultDate(start, end)
        this.emitInput()
      },
      chooseThisMonth() {
        const now = new Date()
        const start = new Date(now.getFullYear(), now.getMonth(), 1)
        const end = new Date(now.getFullYear(), now.getMonth() + 1, 1)
        end.setDate(end.getDate() - 1)
        this.menuShow = false
        this.dataValue = util.formatDate(start, 'yyyy-MM-dd') + ' ~ ' + util.formatDate(end, 'yyyy-MM-dd')
        this.contentValue = this.dataValue
        this.setDefaultDate(start, end)
        this.emitInput()
      },
      chooseLastMonth() {
        let now = new Date()
        now = new Date(now.getFullYear(), now.getMonth() - 1, 1)
        const start = new Date(now.getFullYear(), now.getMonth(), 1)
        const end = new Date(now.getFullYear(), now.getMonth() + 1, 1)
        end.setDate(end.getDate() - 1)
        this.menuShow = false
        this.dataValue = util.formatDate(start, 'yyyy-MM-dd') + ' ~ ' + util.formatDate(end, 'yyyy-MM-dd')
        this.contentValue = this.dataValue
        this.setDefaultDate(start, end)
        this.emitInput()
      },
      chooseThisYear() {
        const now = new Date()
        const start = new Date(now.getFullYear(), 0, 1)
        const end = new Date(now.getFullYear() + 1, 0, 1)
        end.setDate(end.getDate() - 1)
        this.menuShow = false
        this.dataValue = util.formatDate(start, 'yyyy-MM-dd') + ' ~ ' + util.formatDate(end, 'yyyy-MM-dd')
        this.contentValue = this.dataValue
        this.setDefaultDate(start, end)
        this.emitInput()
      },
      chooseLastYear() {
        let now = new Date()
        now = new Date(now.getFullYear() - 1, 0, 1)
        const start = new Date(now.getFullYear(), 0, 1)
        const end = new Date(now.getFullYear() + 1, 0, 1)
        end.setDate(end.getDate() - 1)
        this.menuShow = false
        this.dataValue = util.formatDate(start, 'yyyy-MM-dd') + ' ~ ' + util.formatDate(end, 'yyyy-MM-dd')
        this.contentValue = this.dataValue
        this.setDefaultDate(start, end)
        this.emitInput()
      },
      setDefaultDate(start, end) {
        this.minDate = start
        this.maxDate = end
        this.leftDate = start
        this.rightDate = end
        this.nannSearch = ''
      },
      chooseDay() {
        this.menuShow = false
        // this.inputValueShow = false
        this.chooseDayMenuShow = true
        // this.chooseDayValue = this.dataValue
        // this.$refs.datePicker.pickerVisible = true
        this.getThumbLeft(324)
      },
      chooseRange() {
        this.menuShow = false
        this.chooseDayMenuShow = false
        this.chooseRangeMenuShow = true
        this.getThumbLeft(582)
      },
      clear() { // clear btn click event
        this.dataValue = ''
        this.nannSearch = ''
        this.chooseDayValue = ''
        this.minDate = ''
        this.maxDate = ''
        this.minTime = ''
        this.maxTime = ''
        this.menuType = 'all'
        this.chooseDayMenuShow = false
        this.chooseRangeMenuShow = false
        this.inputValueShow = true
        this.submitShow = true
        this.contentValue = this.placeholder
        this.leftDate = new Date()
        this.rightDate = nextMonth(this.leftDate)
        this.rangeState.selecting = false
        this.emitInput()
      },
      emitInput() {
        let value = this.getValue()
        this.$emit('input', value)
        this.$emit('content-value', this.contentValue)
      },
      getValue() {
        let value = ''
        if (this.nannSearch) {
          value = this.nannSearch
        } else if (this.dataValue) {
          let theValue = this.dataValue.split(' ~ ')
          if (theValue.length > 1) {
            value = [theValue[0], theValue[1]]
          } else {
            value = this.dataValue
          }
        }
        return value
      },
      handleNANNSearchChange(mode) { // 选择NANN搜索事件
        this.dataValue = ''
        this.nannSearch = mode
        this.menuShow = false
        this.contentValue = this.placeholder
        this.emitInput()
      },
      leftPrevYear() {
        if (this.currentLeftView === 'year') {
          this.leftDate = prevYear(this.leftDate, 10)
        } else {
          this.leftDate = prevYear(this.leftDate)
          if (!this.unlinkPanels) {
            this.rightDate = nextMonth(this.leftDate)
          }
        }
      },

      leftPrevMonth() {
        this.leftDate = prevMonth(this.leftDate)
        if (!this.unlinkPanels) {
          this.rightDate = nextMonth(this.leftDate)
        }
      },

      rightNextYear() {
        if (this.currentRightView === 'year') {
          this.rightDate = nextYear(this.rightDate, 10)
        } else {
          if (!this.unlinkPanels) {
            this.leftDate = nextYear(this.leftDate)
          }
          this.rightDate = nextYear(this.rightDate)
        }
      },

      rightNextMonth() {
        if (!this.unlinkPanels) {
          this.leftDate = nextMonth(this.leftDate)
          this.rightDate = nextMonth(this.leftDate)
        } else {
          this.rightDate = nextMonth(this.rightDate)
        }
      },

      // leftNext*, rightPrev* are called when `unlinkPanels` is true
      leftNextYear() {
        if (this.currentLeftView === 'year') {
          this.leftDate = nextYear(this.leftDate, 10)
        } else {
          this.leftDate = nextYear(this.leftDate)
        }
      },

      leftNextMonth() {
        this.leftDate = nextMonth(this.leftDate)
      },

      rightPrevYear() {
        if (this.currentRightView === 'year') {
          this.rightDate = prevYear(this.rightDate, 10)
        } else {
          this.rightDate = prevYear(this.rightDate)
        }
      },
      rightPrevMonth() {
        this.rightDate = prevMonth(this.rightDate)
      },
      toggleSearchModePanel() {
        this.chooseRangeMenuShow = false
        this.chooseDayMenuShow = false
        this.menuShow = !this.menuShow
      },
      getThumbLeft(width) {
        let thumb = this.$refs['searchInput'].getBoundingClientRect()
        let clientWidth = `${document.documentElement.clientWidth}`

        // 如果居中，两侧需要的最小宽度
        let needMinFreeWidth = (width - thumb.width) / 2
        // 左侧剩余宽度
        let leftFreeWidth = thumb.left
        // 右侧剩余宽度
        let rightFreeWidth = clientWidth - thumb.left - thumb.width
        // 两个剩余宽度都足够时，居中显示
        if (leftFreeWidth >= needMinFreeWidth && rightFreeWidth >= needMinFreeWidth) {
          this.menuLeft = thumb.left - (width - thumb.width) / 2
        } else if (rightFreeWidth < needMinFreeWidth && leftFreeWidth > (width - rightFreeWidth - thumb.width + 4)) {
          // 如果右侧不足时，多向左侧移4px
          this.menuLeft = thumb.left - (width - rightFreeWidth - thumb.width + 4)
        } else if (leftFreeWidth < needMinFreeWidth && rightFreeWidth > (width - leftFreeWidth - thumb.width + 4)) {
          // 如果左侧不足时，多向右侧移4px
          this.menuLeft = thumb.left - leftFreeWidth + 4
        } else {
          this.menuLeft = thumb.left - (width - thumb.width) / 2
        }
      },
      submitData() {
        if (!close || this.showTime) return
        let format = 'yyyy-MM-dd'
        let minDateVal = ''
        let maxDateVal = ''
        this.contentValue = this.placeholder
        minDateVal = util.formatDate(this.minDate, format)
        maxDateVal = util.formatDate(this.maxDate, format)
        if (this.maxDate && this.minDate) {
          this.chooseRangeMenuShow = false
          if (minDateVal + ' ' + this.minTime === maxDateVal + ' ' + this.maxTime) {
            this.dataValue = this.dateType === 'date' ? minDateVal : minDateVal + ' ' + this.minTime
          } else {
            if (this.dateType === 'datetime') {
              minDateVal = minDateVal + ' ' + this.minTime + ':00'
              maxDateVal = maxDateVal + ' ' + this.maxTime + ':59'
            }
            this.dataValue = minDateVal + ' ~ ' + maxDateVal
            this.leftDate = this.minDate
            this.rightDate = this.maxDate
          }
          this.contentValue = this.dataValue
          this.emitInput()
        }
      },
      clickTime() {
        const nowDate = new Date()
        if (this.maxDate == null || this.maxDate === '') {
          this.maxDate = nowDate
          this.maxTime = util.formatDate(this.maxDate, 'HH:mm')
        }
        if (this.minDate == null || this.minDate === '') {
          this.minDate = nowDate
          this.minTime = util.formatDate(this.minDate, 'HH:mm')
        }
        if (!this.maxTime) {
          this.maxTime = util.formatDate(nowDate, 'HH:mm')
        }
        if (!this.minTime) {
          this.minTime = util.formatDate(nowDate, 'HH:mm')
        }
        this.submitShow = false
      },
      handleSwitch() {
        if (this.menuShow || this.chooseDayMenuShow || this.chooseRangeMenuShow) {
          this.handleClose()
        } else {
          this.showMenu()
        }
      }
    },
    watch: {
      value: function (newValue) {
        if (newValue === undefined || newValue === '') {
          this.clear()
        } else if (newValue === 'null' || newValue === '!null') { // if val equal nannSearch
          this.nannSearch = newValue
        } else {
          if (newValue instanceof Array) {
            // 替换-为/ 兼容ie
            this.minDate = new Date(newValue[0].replace(/-/g, '/'))
            this.maxDate = new Date(newValue[1].replace(/-/g, '/'))
            let reg = /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/
            let regExp = new RegExp(reg)
            if (this.dateType === 'datetime' && regExp.test(newValue[0]) && regExp.test(newValue[1])) {
              this.minTime = util.formatDate(this.minDate, 'HH:mm')
              this.maxTime = util.formatDate(this.maxDate, 'HH:mm')
            }
            this.leftDate = this.minDate
            this.rightDate = this.maxDate
            this.nannSearch = ''
            this.dataValue = newValue[0] + ' ~ ' + newValue[1]
            this.contentValue = this.dataValue
            this.$emit('content-value', this.contentValue)
          } else {
            this.dataValue = newValue
            this.contentValue = this.dataValue
            this.$emit('content-value', this.contentValue)
          }
        }
      },
      chooseDayValue: function (chooseValue) {
        this.dataValue = chooseValue
        this.emitInput()
      }
    },
    components: {YearTable, MonthTable, DateTable}
  }
</script>

<style src="../whaty-search-select/index.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/components/whaty-search-date-picker/index.vue